import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DailyTaskRow, useDailyTaskQuery } from '@features/DailyTask';
import { useGrammarReviewQuery } from '@features/Grammar/model/queries';
import { useStoriesHubQuery } from '@features/Stories/model/queries';
import { paths } from '@shared/config';
import { cn } from '@shared/lib';
import { MissionRow } from './MissionRow';
import { ReviewRow } from './ReviewRow';

/**
 * «На сегодня» — «Задание дня», «Миссия дня» и подборка повторения грамматики одной плашкой (решение владельца
 * 2026-10-23: «две огромные плашки слишком много для ежедневок»; подборка — 2026-10-25). Строка, чьи данные не пришли или
 * которой сегодня нет, не рисуется; не пришло ничего — плашки нет.
 */
export function DailiesCard({ phone }: { phone: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const task = useDailyTaskQuery().data;
  const hub = useStoriesHubQuery().data;
  const review = useGrammarReviewQuery().data;
  if (!task && !hub && !review) return null;

  return (
    <section
      aria-labelledby="dash-dailies-title"
      // Сверху на широкой колонке — 28 px, как у тренировки: надзаголовки на одной линии (DashboardPage.css).
      className={cn('dash-dailies flex flex-col rounded-card border border-solid border-accent/25 bg-card', phone ? 'p-4' : 'px-6 py-5')}
    >
      <h2 id="dash-dailies-title" className="mb-3 text-[12px] font-semibold uppercase leading-4 tracking-[0.14em] text-muted">
        {t('dashboard.home.dailies.title')}
      </h2>
      {/* Строки подряд: 12 px, черта, 12 px — плашка по своим строкам, не по высоте соседки (владелец 2026-10-26). */}
      <div className="flex flex-col divide-y divide-line [&>*:first-child]:pb-3 [&>*:last-child]:pt-3 [&>*:not(:first-child):not(:last-child)]:py-3 [&>*:only-child]:py-0">
        <DailyTaskRow onOpen={() => navigate(paths.dailyTask)} />
        <MissionRow />
        <ReviewRow />
      </div>
    </section>
  );
}
